import { hasRole, isAdminNotConsultant, isHolding } from "@/js/http/auth.js";
import StockList from "@/components/stock/StockListComponent.vue";
import MvtStockList from "@/components/stock/MvtStockListComponent.vue";
import PurchaseOrderList from "@/components/purchase-orders/PurchaseOrderList.vue";
import WarehouseList from "@/components/warehouse/WarehouseList.vue";
import SupplierPricesList from "@/components/supplier-prices/SupplierPricesList.vue";
import AdminInventorySubMenusLinks from "@/components/menu/sub-menus/inventory/AdminInventorySubMenusLinks.vue";
export default {
  name: "adminStockList",
  components: {
    PurchaseOrderList: PurchaseOrderList,
    StockList: StockList,
    MvtStockList: MvtStockList,
    WarehouseList: WarehouseList,
    SupplierPricesList: SupplierPricesList,
    AdminInventorySubMenusLinks: AdminInventorySubMenusLinks
  },
  props: ["loggedUserData"],
  data: function data() {
    return {
      canManage: false,
      canManagePos: false,
      canAccessSourcing: false,
      canManageSupplierPrices: false,
      canManageWarehouses: false,
      selectedTab: null,
      tabs: {
        items: "items",
        purchaseOrder: "purchaseOrder",
        sourcing: "sourcing",
        supplierPrices: "supplierPrices",
        movements: "movements",
        warehouses: "warehouses"
      }
    };
  },
  created: function created() {
    this.canManage = hasRole(process.env.VUE_APP_ROLES_MANAGE_STOCK);
    this.canManagePos = hasRole(process.env.VUE_APP_ROLES_MANAGE_PURCHASE_ORDERS);
    this.canAccessSourcing = hasRole(process.env.VUE_APP_ROLES_ACCESS_SOURCING);
    this.canManageSupplierPrices = hasRole(process.env.VUE_APP_ROLES_MANAGE_SUPPLIER_PRICES);
    this.canManageWarehouses = hasRole(process.env.VUE_APP_ROLES_MANAGE_WAREHOUSES);
    this.selectedTab = this.$route.query.tab || this.tabs.items;
  },
  methods: {
    tabChanged: function tabChanged(tab) {
      this.selectedTab = tab;
    },
    isAdminNotConsultant: isAdminNotConsultant,
    isHolding: isHolding
  }
};